export default "__VITE_ASSET__BW63rtGV__"